export default __webpack_public_path__ + "static/IR_Contacts_01-3a8bba51a57c1f1adea2e8026c3b8a4f.jpg";